import React, { memo } from 'react';

import { defaultSize, sizePropsTypes } from './icons.constants';

const FloatIcon = ({ size = defaultSize, ...props }) => (
  <svg
    fill="none"
    height={size}
    viewBox="0 0 24 24"
    width={size}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      clipRule="evenodd"
      d="M2.92676 4C2.92676 3.44772 3.37447 3 3.92676 3H19.9268C20.479 3 20.9268 3.44772 20.9268 4C20.9268 4.55228 20.479 5 19.9268 5H3.92676C3.37447 5 2.92676 4.55228 2.92676 4ZM2.92676 9C2.92676 8.44772 3.37447 8 3.92676 8H19.9268C20.479 8 20.9268 8.44772 20.9268 9C20.9268 9.55228 20.479 10 19.9268 10H3.92676C3.37447 10 2.92676 9.55228 2.92676 9ZM2.92676 14C2.92676 13.4477 3.37447 13 3.92676 13H8.92676C9.47904 13 9.92676 13.4477 9.92676 14C9.92676 14.5523 9.47904 15 8.92676 15H3.92676C3.37447 15 2.92676 14.5523 2.92676 14ZM12.9268 15C12.9268 13.8954 13.8222 13 14.9268 13H18.9268C20.0313 13 20.9268 13.8954 20.9268 15V19C20.9268 20.1046 20.0313 21 18.9268 21H14.9268C13.8222 21 12.9268 20.1046 12.9268 19V15ZM18.9268 15H14.9268V19H18.9268V15ZM2.92676 20C2.92676 19.4477 3.37447 19 3.92676 19H8.92676C9.47904 19 9.92676 19.4477 9.92676 20C9.92676 20.5523 9.47904 21 8.92676 21H3.92676C3.37447 21 2.92676 20.5523 2.92676 20Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </svg>
);

FloatIcon.propTypes = {
  ...sizePropsTypes,
};

export default memo(FloatIcon);
